module.exports = __webpack_public_path__ + "static/media/DSC_0140-2.0316a346.jpg";